import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Home.css";
import bedImage from "../assets/images/bed.png";

// Import blog images with fallback handling
let blog1, blog2, blog3, blog4, blog5, blog6;
let incubated, incubatedamitz;
let certifiedlogo1, certifiedlogo2;

try {
  blog1 = require("../assets/images/blog1.jpg");
  blog2 = require("../assets/images/blog2.jpg");
  blog3 = require("../assets/images/blog3.jpg");
  blog4 = require("../assets/images/blog4.jpg");
  blog5 = require("../assets/images/blog5.jpg");
  blog6 = require("../assets/images/blog6.jpg");
  incubated = require("../assets/images/incubated.jpg");
  incubatedamitz = require("../assets/images/incubatedamitz.jpg");
  certifiedlogo1 = require("../assets/images/certifiedlogo1.jpg");
  certifiedlogo2 = require("../assets/images/certifiedlogo2.jpg");
} catch (error) {
  console.log("Some images not found, using placeholders");
}

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  const incubatedPartners = [
    {
      id: 1,
      image:
        incubated ||
        "https://via.placeholder.com/300x200?text=Incubated+Partner",
      alt: "Incubated Partner",
      fallbackText: "Incubated Partner",
    },
    {
      id: 2,
      image:
        incubatedamitz ||
        "https://via.placeholder.com/300x200?text=Incubated+Amitz",
      alt: "Incubated Amitz",
      fallbackText: "Incubated Amitz",
    },
  ];

  const certifiedPartners = [
    {
      id: 1,
      image:
        certifiedlogo1 ||
        "https://via.placeholder.com/300x200?text=Certified+Partner+1",
      alt: "Certified Partner 1",
      fallbackText: "Certified Partner 1",
    },
    {
      id: 2,
      image:
        certifiedlogo2 ||
        "https://via.placeholder.com/300x200?text=Certified+Partner+2",
      alt: "Certified Partner 2",
      fallbackText: "Certified Partner 2",
    },
  ];

  const featuredBlogs = [
    {
      id: 1,
      heading: "Padma Shri Chintakindi Mallesham's Visit",
      content:
        "Padma Shri awardee Chintakindi Mallesham visited our University...",
      icon: "bi-award",
      image:
        blog1 ||
        "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      link: "/blog#post1",
    },
    {
      id: 2,
      heading: "Dr. B. Koteswara Rao and Team's Visit",
      content: "Dr. B. Koteswara Rao - General Surgeon, Dr. P V Krishna Rao...",
      icon: "bi-award",
      image:
        blog2 ||
        "https://images.unsplash.com/photo-1582750433449-648ed127bb54?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      link: "/blog#post2",
    },
    {
      id: 3,
      heading: "KCP Cements HoDs' Visit",
      content: "KCP Cements Quality HoDs, Bhava Narayana, V Srinivasa Rao...",
      icon: "bi-award",
      image:
        blog3 ||
        "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      link: "/blog#post3",
    },
    {
      id: 4,
      heading: "Dr. P V Radha Devi's Visit",
      content:
        "Dr. P V Radha Devi, Outstanding Scientist and Director, ADRIN...",
      icon: "bi-award",
      image:
        blog4 ||
        "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      link: "/blog#post4",
    },
    {
      id: 5,
      heading: "Sri Yendamuri Veerendranath's Visit",
      content: "Sri Yendamuri Veerendranath, Writer and Director, Hyderabad...",
      icon: "bi-award",
      image:
        blog5 ||
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      link: "/blog#post5",
    },
    {
      id: 6,
      heading: "Minister Kondapalli Srinivas' Visit",
      content:
        "Sri Kondapalli Srinivas, Minister of MSME, SERP, NRI Empowerment...",
      icon: "bi-award",
      image:
        blog6 ||
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      link: "/blog#post6",
    },
  ];

  const carouselSlides = [
    {
      image:bedImage,
      title: "Discover Our Products",
      subtitle: "Explore our innovative healthcare products and solutions.",
      link: "/products",
      buttonText: "View Products",
    },
    {
      image:
        "https://smartclinix.net/wp-content/uploads/2021/11/Medical-billing-services-1.jpg",
      title: "Our Healthcare Services",
      subtitle: "Check out our comprehensive range of healthcare services.",
      link: "/services",
      buttonText: "Get Started",
    },
    {
      image: "https://www.go.ooo/img/bg-img/Login.jpg",
      title: "Smart Health Monitoring",
      subtitle: "Real-time AI-powered insights for proactive healthcare.",
      link: "/signup",
      buttonText: "Join Today",
    },
   
  ];

  return (
    <div className="home-container">
      {/* Background Design */}
      <div className="background-design">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
      </div>

      <div className="content-wrapper">
        {/* Carousel */}
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={0}
          slidesPerView={1}
          autoplay={{ delay: 6000, disableOnInteraction: false }}
          pagination={{ clickable: true, dynamicBullets: true }}
          navigation={true}
          loop={true}
          effect="fade"
          className="position-relative"
        >
          {carouselSlides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="carousel-slide"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="carousel-overlay"></div>
                <div className="carousel-content">
                  <motion.h1
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="display-3 fw-bold mb-4"
                  >
                    {slide.title}
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="lead mb-5"
                  >
                    {slide.subtitle}
                  </motion.p>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.6 }}
                  >
                    <Link
                      to={slide.link}
                      className="carousel-btn hover-lift glow-effect"
                    >
                      {slide.buttonText}
                    </Link>
                  </motion.div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Healthcare Solutions */}
        <div className="section-enhanced">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h2 className="section-title display-4">
                Our Healthcare Solutions
              </h2>
              <p className="section-subtitle">
                Designed with care, built for impact
              </p>
            </div>
            <div className="row g-4">
              {[
                {
                  icon: "bi-hospital",
                  title: "Patient-Centric Design",
                  description:
                    "Our products prioritize patient comfort and caregiver convenience with intuitive interfaces.",
                  color: "#42a5f5",
                },
                {
                  icon: "bi-cpu",
                  title: "Smart Technology",
                  description:
                    "Advanced IoT solutions integrated with AI for modern healthcare challenges.",
                  color: "#42a5f5",
                },
                {
                  icon: "bi-currency-rupee",
                  title: "Affordable Solutions",
                  description:
                    "High-quality healthcare products designed to be accessible and cost-effective.",
                  color: "#42a5f5",
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay={index * 150}
                >
                  <motion.div
                    className="feature-card text-center hover-lift glow-effect"
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="feature-icon">
                      <i className={`bi ${feature.icon}`}></i>
                    </div>
                    <h3
                      className="h4 mb-3 fw-bold"
                      style={{ color: feature.color }}
                    >
                      {feature.title}
                    </h3>
                    <p className="text-muted lh-lg">{feature.description}</p>
                  </motion.div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Incubated At */}
        <div>
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="section-title display-4">Incubated At</h2>
            <p className="section-subtitle">
              Proudly supported by leading innovation centers
            </p>
          </div>
          <div className="row justify-content-center g-4 p-5">
            {incubatedPartners.map((partner, index) => (
              <div
                key={partner.id}
                className="col-md-4 col-lg-3"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <motion.div
                  className="incubated-border-box"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <img
                    src={partner.image}
                    alt={partner.alt}
                    className="incubated-image"
                    onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/250?text=Partner+Logo")
                    }
                  />
                </motion.div>
              </div>
            ))}
          </div>
        

        {/* Certified With */}
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="section-title display-4">Certified With</h2>
            <p className="section-subtitle">
              Recognized by premier healthcare certification authorities
            </p>
          </div>
          <div className="row justify-content-center g-4 p-5">
            {certifiedPartners.map((partner, index) => (
              <div
                key={partner.id}
                className="col-md-4 col-lg-3"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <motion.div
                  className="incubated-border-box"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <img
                    src={partner.image}
                    alt={partner.alt}
                    className="incubated-image"
                    onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/250?text=Certified+Logo")
                    }
                  />
                </motion.div>
              </div>
            ))}
          </div>
      </div>

        {/* Latest Updates */}
        <div className="section-enhanced">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h2 className="section-title display-4">Latest Updates</h2>
              <p className="section-subtitle">
                Stay informed with our recent activities and achievements
              </p>
            </div>

            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              className="blog-swiper pb-5"
            >
              {featuredBlogs.map((blog) => (
                <SwiperSlide key={blog.id}>
                  <motion.div
                    whileHover={{ y: -10 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Link to={blog.link} className="text-decoration-none">
                      <div className="blog-card hover-lift glow-effect">
                        <div className="blog-image-container">
                          <img
                            src={blog.image}
                            alt={blog.content}
                            className="blog-image"
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.nextSibling.style.display = "flex";
                            }}
                          />
                          <div
                            className="image-placeholder"
                            style={{ display: "none", height: "100%" }}
                          >
                            <div>
                              <i className="bi bi-image fs-1 mb-2"></i>
                              <div>Blog Image</div>
                            </div>
                          </div>
                          <div className="blog-overlay">
                            <i className="bi bi-eye-fill"></i>
                          </div>
                        </div>
                        <div className="card-body p-4">
                          <div className="d-flex align-items-center mb-3">
                            <div
                              className="feature-icon me-3"
                              style={{
                                width: "50px",
                                height: "50px",
                                fontSize: "1.2rem",
                              }}
                            >
                              <i className={`bi ${blog.icon}`}></i>
                            </div>
                            <h3 className="h5 mb-0 fw-bold text-primary">
                              {blog.heading}
                            </h3>
                          </div>
                          <p className="text-muted lh-lg">{blog.content}</p>
                          <div className="mt-3">
                            <span className="text-primary fw-semibold">
                              Read More →
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="text-center mt-5" data-aos="fade-up">
              <Link to="/blog" className="btn-enhanced btn-lg">
                <i className="bi bi-journal-text me-2"></i>
                View All Updates
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
